import { defineEvent } from '../types/event';
export var CUSTOMER_SIGNUP = defineEvent({
    platforms: [
        {
            name: 'GTM',
            alias: 'customerSignUp'
        }
    ]
});
